import React from 'react';
import { ProjectGq } from './../../graphql/projects/models/ProjectGq';

export function useProjectPageTitle(section: string, project?: ProjectGq) {
  React.useEffect(() => {
    const devPrefix = window.location.href.includes('localhost') ? 'Dev | ' : '';
    document.title = `${devPrefix}${section} | ${project?.name}`;
  }, [project?.name, section]);
}
